import { isServer } from '@bob/library'
import { AppProviderContext } from '@websrc/App/AppContext'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { matomo } from '@websrc/App/Tracking/Matomo'
import React, { useContext, useRef } from 'react'

import * as SC from './LessonStudentMaterial.style'
import { useFixedScroll } from './useFixedScroll'

export interface LessonStudentMaterialProps {
  url?: string
  pdfLink?: string
  fixedScrollTopOffset?: number
}

export const LessonStudentMaterial = ({
  url,
  pdfLink,
  fixedScrollTopOffset = 0,
}: LessonStudentMaterialProps) => {
  const t = useStaticText()
  const { matomoPageTemplate } = useContext(AppProviderContext)
  const wrapperRef = useRef<HTMLDivElement>(null)
  const contentRef = useRef<HTMLDivElement>(null)

  const wrapperProps = useFixedScroll(wrapperRef, contentRef, fixedScrollTopOffset)

  if (!url && !pdfLink) {
    return null
  }

  return (
    <SC.Wrapper data-testid={'student-material'} ref={wrapperRef}>
      <SC.FixedWrapper ref={contentRef} {...wrapperProps}>
        <SC.Title>{t.plans_lessons_worksheets.student_material}</SC.Title>
        <SC.Content>
          {(pdfLink || url) && (
            <>
              <SC.Subtitle>{t.plans_lessons_worksheets.student_worksheet}</SC.Subtitle>
              <SC.ContentDescription>
                {pdfLink
                  ? t.plans_lessons_worksheets.download_pdf_description
                  : t.plans_lessons_worksheets.view_online_description}
              </SC.ContentDescription>
              {pdfLink && (
                <SC.ContentActions>
                  <SC.DownloadSW href={pdfLink} target={'_blank'}>
                    {t.plans_lessons_worksheets.download_pdf}
                  </SC.DownloadSW>
                </SC.ContentActions>
              )}
              {url && (
                <SC.ContentActions>
                  <SC.ViewSW
                    onClick={() =>
                      matomo.trackEvent(
                        'engagement',
                        matomoPageTemplate,
                        [t.plans_lessons_worksheets.student_material],
                        [t.plans_lessons_worksheets.view_online],
                        'button'
                      )
                    }
                    to={url}
                  >
                    {t.plans_lessons_worksheets.view_online}
                  </SC.ViewSW>
                </SC.ContentActions>
              )}
            </>
          )}
        </SC.Content>
        {pdfLink && (
          <SC.Content>
            <SC.Subtitle>{t.print_and_share.share_with}</SC.Subtitle>
            <SC.ButtonHyperlink
              href={`https://classroom.google.com/share?url=${encodeURIComponent(
                isServer ? `` : `${window.location.origin}${pdfLink}`
              )}`}
            >
              <SC.GoogleImage
                alt={t.plans_lessons_worksheets.google_classroom}
                src={'https://assets.education.lego.com/_/images/google-classroom.png'}
              />
              <span>{t.plans_lessons_worksheets.google_classroom}</span>
            </SC.ButtonHyperlink>
          </SC.Content>
        )}
      </SC.FixedWrapper>
    </SC.Wrapper>
  )
}
